import React from 'react';
import JsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import iconDownload from '../../assets/images/botao_download.svg';
import './index.css';

const DownloadGraphics = ({ refChartContainer, name, isTagGraphic }) => {
  const downloadChart = () => {
    if (isTagGraphic && refChartContainer && refChartContainer.current) {
      const containerHeight = refChartContainer.current.clientHeight;
      const containerWidth = refChartContainer.current.clientWidth;

      html2canvas(refChartContainer.current).then((canvas) => {
        const img = canvas.toDataURL('image/jpeg');

        const orietation = containerHeight > containerWidth ? 'p' : 'l';

        const MARGIN = 5;
        const doc = new JsPDF(orietation, 'pt', [
          containerWidth + MARGIN * 2,
          containerHeight + MARGIN * 2,
        ]);

        const width = doc.internal.pageSize.getWidth();
        const height = doc.internal.pageSize.getHeight();
        const widthRatio = width / canvas.width;
        const heightRatio = height / canvas.height;

        const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

        doc.addImage(
          img,
          'JPEG',
          MARGIN,
          MARGIN,
          canvas.width * ratio,
          canvas.height * ratio
        );
        doc.save(`${name}.pdf`);
      });
    } else if (
      refChartContainer &&
      refChartContainer.current &&
      refChartContainer.current.chart
    ) {
      refChartContainer.current.chart.exportChart({
        type: 'application/pdf',
        filename: name,
      });
    }
  };

  return (
    <img
      src={iconDownload}
      alt="iconDownload"
      onClick={downloadChart}
      className="icon-download-graphic"
    />
  );
};

export default DownloadGraphics;
